import classNames from 'classnames'
import useScrollInfo from 'hooks/useScrollInfo'
import { useRef } from 'react'
import styles from './index.module.scss'

interface ScrollHorizontallyProps {
  containerClass?: string
  childrenClass?: string
  redesignScroll?: boolean
}

const ScrollHorizontally: React.FC<ScrollHorizontallyProps> = ({
  containerClass = '',
  redesignScroll,
  childrenClass = '',
  children,
}) => {
  // show or hide shade based on scroll
  const containerRef = useRef(null)
  const scrollInfo = useScrollInfo(containerRef)

  return (
    <div
      className={classNames(
        'd-inline-flex flex-nowrap overflow-hidden position-relative h-auto',
        containerClass
      )}
    >
      <div
        ref={containerRef}
        className={classNames(
          childrenClass,
          styles.scroll_container,
          { 'hide-scrollbar': !redesignScroll },
          'overflow-auto'
        )}
      >
        {children}
      </div>
      <div
        className={
          redesignScroll
            ? classNames(styles.newShade, {
                [styles.left_new_shade]: scrollInfo.x.position > 0,
              })
            : classNames(styles.shade, {
                [styles.left_shade]: scrollInfo?.x.position > 0,
              })
        }
      />
      <div
        className={
          redesignScroll
            ? classNames(styles.newShade, {
                [styles.right_new_shade]:
                  scrollInfo?.x.hasOverflow && !scrollInfo?.x.isMaxScroll,
              })
            : classNames(styles.shade, {
                [styles.right_shade]:
                  scrollInfo?.x.hasOverflow && !scrollInfo?.x.isMaxScroll,
              })
        }
      />
    </div>
  )
}

export default ScrollHorizontally
